// extracted by mini-css-extract-plugin
export default {"popup":"PopupHeader_popup__MTgW2","popup_open":"PopupHeader_popup_open__pJZV0","popup__close":"PopupHeader_popup__close__CDpjH"};